import * as i0 from '@angular/core';
import { Component, Input, Injectable, Directive, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@tn-equis/core/services';
import { EquisComponentInsertionService } from '@tn-equis/core/services';

class EquisRippleComponent {
}
EquisRippleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisRippleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EquisRippleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: EquisRippleComponent, selector: "z-ripple, equis-ripple", inputs: { backgroundColor: "backgroundColor" }, ngImport: i0, template: "<span\n  class=\"ripple__animation\"\n  [ngStyle]=\"{ 'background-color': backgroundColor }\"\n></span>\n", styles: [".ripple__animation{animation:expand-ripple .3s linear forwards;border-radius:50%;pointer-events:none;position:absolute}@keyframes expand-ripple{0%{opacity:1;transform:scale(0)}to{opacity:0;transform:scale(1)}}\n"], dependencies: [{ kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisRippleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'z-ripple, equis-ripple', template: "<span\n  class=\"ripple__animation\"\n  [ngStyle]=\"{ 'background-color': backgroundColor }\"\n></span>\n", styles: [".ripple__animation{animation:expand-ripple .3s linear forwards;border-radius:50%;pointer-events:none;position:absolute}@keyframes expand-ripple{0%{opacity:1;transform:scale(0)}to{opacity:0;transform:scale(1)}}\n"] }]
        }], propDecorators: { backgroundColor: [{
                type: Input
            }] } });

class EquisRipplePositionService {
    getPosition(host, clickPosition) {
        const minAnimationSpeed = 800;
        const hostRect = host.getBoundingClientRect();
        const radiousSize = hostRect.height > hostRect.width ? hostRect.height : hostRect.width;
        // se multiplica por 1000 para trabajar en ms en vez de s
        const animationSpeed = (Math.sqrt(radiousSize) / 70 + 0.2) * 1000;
        const ripplePosition = {
            animationDuration: animationSpeed > minAnimationSpeed ? minAnimationSpeed : animationSpeed,
            top: clickPosition.posY - hostRect.top - radiousSize,
            left: clickPosition.posX - hostRect.left - radiousSize,
            height: radiousSize * 2,
            width: radiousSize * 2,
        };
        return ripplePosition;
    }
}
EquisRipplePositionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisRipplePositionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EquisRipplePositionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisRipplePositionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisRipplePositionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class EquisRippleDirective {
    constructor(el, componentInsertionService, positionService) {
        this.el = el;
        this.componentInsertionService = componentInsertionService;
        this.positionService = positionService;
        this.rippleDisabled = false;
    }
    onClick(click) {
        if (!this.rippleDisabled) {
            this._clickPos = { posX: click.clientX, posY: click.clientY };
            this.show();
        }
    }
    show() {
        const rippleId = this.componentInsertionService.create(EquisRippleComponent, this.el.nativeElement);
        this.allocate(rippleId);
    }
    allocate(rippleId) {
        if (this.rippleBackgroundColor) {
            this.componentInsertionService.setProperty(rippleId, 'backgroundColor', this.rippleBackgroundColor);
        }
        if (this.rippleClassBackgroundColor) {
            this.componentInsertionService.addClass(rippleId, this.rippleClassBackgroundColor);
        }
        const ripplePosition = this.positionService.getPosition(this.el.nativeElement, this._clickPos);
        this.componentInsertionService.setStyle(rippleId, 'width', `${ripplePosition.width}px`);
        this.componentInsertionService.setStyle(rippleId, 'height', `${ripplePosition.height}px`);
        this.componentInsertionService.setStyle(rippleId, 'animation-duration', `${ripplePosition.animationDuration}ms`);
        this.componentInsertionService.setPosition(rippleId, ripplePosition);
        // Se suma 10 a la duracion para asegurarse que termine de animar antes de eliminarse
        setTimeout(() => {
            this.hide(rippleId);
        }, ripplePosition.animationDuration + 10);
    }
    hide(rippleId) {
        this.componentInsertionService.destroy(rippleId);
    }
}
EquisRippleDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisRippleDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.EquisComponentInsertionService }, { token: EquisRipplePositionService }], target: i0.ɵɵFactoryTarget.Directive });
EquisRippleDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.3.0", type: EquisRippleDirective, selector: "[zRipple], [equisRipple]", inputs: { rippleBackgroundColor: "rippleBackgroundColor", rippleClassBackgroundColor: "rippleClassBackgroundColor", rippleDisabled: "rippleDisabled" }, host: { listeners: { "click": "onClick($event)" } }, exportAs: ["zRipple", "equisRipple"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisRippleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[zRipple], [equisRipple]',
                    exportAs: 'zRipple, equisRipple',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.EquisComponentInsertionService }, { type: EquisRipplePositionService }]; }, propDecorators: { rippleBackgroundColor: [{
                type: Input
            }], rippleClassBackgroundColor: [{
                type: Input
            }], rippleDisabled: [{
                type: Input
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class EquisRippleModule {
    static forRoot() {
        return {
            ngModule: EquisRippleModule,
        };
    }
}
EquisRippleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisRippleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EquisRippleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: EquisRippleModule, declarations: [EquisRippleComponent, EquisRippleDirective], imports: [CommonModule], exports: [EquisRippleComponent, EquisRippleDirective] });
EquisRippleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisRippleModule, providers: [EquisRipplePositionService, EquisComponentInsertionService], imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: EquisRippleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EquisRippleComponent, EquisRippleDirective],
                    imports: [CommonModule],
                    exports: [EquisRippleComponent, EquisRippleDirective],
                    providers: [EquisRipplePositionService, EquisComponentInsertionService],
                }]
        }] });

/*
 * Public API Surface of equis-ripple
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EquisRippleComponent, EquisRippleDirective, EquisRippleModule, EquisRipplePositionService };
